"use client";
import React, { useEffect, useRef, useState } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { showToast, ToastContainer } from "../../util/toastHelper";
import upload_icon from "../../assets/img/upload_icoon.svg";
import mic from '../../assets/img/mute-mic.svg';
import mutemic from '../../assets/img/unmute-mic.svg';
import rightArrow from "../../assets/img/arrow-right.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";

import {
  CallWithAuth,
} from "../../action/apiActions";
import {
  MANAGE_PATIENT_INTAKE_FORM_API_URL,
  PATIENT_INFORMATION_API_URL,
  UPLOAD_CLICNICAL_INTAKE_DOC,
} from "../../action/apiPath";
import { createShortNameFile, createShortNameFileDoc, errorMessageCreate, getFileType } from "../../util/custom";
import { base64ToFile } from "../../util/base64ToFile";
import Header from "../../components/Header";
import { Footer } from "../../components/Footer";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const ManagePaitentIntakeForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [fieldConfig, setFieldConfig] = useState({});

  const [patientDetail, setPatientDetail] = useState({
    referral_info: "",
    present_concern: "",
    medical_history: "",
    developmental_history: "",
    family_history: "",
    social_history: "",
    substance_use_history: "",
    legal_history: "",
    cultural_context: "",
    phychosocial_trauma: "",
    additional_info: "",
    relative_consent: false,
    files: [],
    relatives: [{
      name: "",
      email: "",
      phone: "",
      relative_type: "relative",
    }],
    signature: "",
  });

  const [isSubmit, setIsSubmit] = useState(false);
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);
  const [digitalSignature, setDigitalSignature] = useState("");
  const signaturePadRef = useRef(null);
  const [activeField, setActiveField] = useState(null);

  const [newRelative, setNewRelative] = useState({
    name: "",
    email: "",
    phone: "",
    relative_type: "relative",
  });

  // ✅ Handle text field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatientDetail((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Handle file upload (Reports/Docs)
  const handleFileChange = async (e) => {
    const { files } = e.target;
    const file = files[0];
    if (!file) return;

    const formdata = new FormData();
    formdata.append("file", file);

    setIsFileLoading(true);
    try {
      const response = await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_DOC, formdata);
      let message = errorMessageCreate(response?.res?.data?.message);

      if (response?.res?.data?.statusCode === 200) {
        const uploadedFileUrl = response.res.data.data.file_url;
        const newFile = {
          type: "doc",
          file: uploadedFileUrl,
          report_type_id: "6f1bf9f2-3f09-465b-9884-d657261687f5", // example ID
        };
        setPatientDetail((prev) => ({
          ...prev,
          files: [newFile],
        }));
        showToast("success", "File uploaded successfully.");
      } else {
        showToast("error", message);
      }
    } catch (err) {
      showToast("error", "Error uploading file");
    }
    setIsFileLoading(false);
  };



  // ✅ Handle digital signature saving
  const saveSignature = async (e) => {
    e.preventDefault();
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      setIsSignatureLoading(true);
      const signatureDataURL = signaturePadRef.current.toDataURL();
      let fileName = "digital_signature.jpeg";
      let signature_image = await base64ToFile(
        signatureDataURL,
        fileName,
        "image/jpeg"
      );

      const formdata = new FormData();
      formdata.append("file", signature_image);
      const response = await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_DOC, formdata);
      let message = errorMessageCreate(response?.res?.data?.message);

      if (response?.res?.data?.statusCode === 200) {
        const uploadedSig = response.res.data.data.file_url;
        setDigitalSignature(uploadedSig);
        setPatientDetail((prev) => ({ ...prev, signature: uploadedSig }));
        showToast("success", "Digital signature uploaded successfully");
      } else {
        showToast("error", message);
      }
      setIsSignatureLoading(false);
    } else {
      alert("Please provide a signature before saving.");
    }
  };

  const clearSignature = () => {
    signaturePadRef.current?.clear();
    setDigitalSignature("");
    setPatientDetail((prev) => ({ ...prev, signature: "" }));
  };
  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } =
    useSpeechRecognition();
  const finalTranscriptRef = useRef('');

  if (!browserSupportsSpeechRecognition) {
    alert('Your browser does not support speech recognition.');
  }
  const previousTranscriptRef = useRef('');
  const debounceTimer = useRef(null);
  // 👂 Track only new spoken text
  useEffect(() => {
    if (!activeField) return;
    // Clear any pending update
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    // Set a delay before appending to formData
    debounceTimer.current = setTimeout(() => {
      const prev = previousTranscriptRef.current;
      const delta = transcript.slice(prev.length);
      if (delta.trim()) {
        setPatientDetail((prevData) => ({
          ...prevData,
          [activeField]: (prevData[activeField] || '') + ' ' + delta.trim(),
        }));
        previousTranscriptRef.current = transcript;
      }
    }, 1000); // wait 1 second for the phrase to settle
  }, [transcript, activeField]);
  const checkMicPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Mic granted, you can stop the stream immediately
      stream.getTracks().forEach(track => track.stop());
      console.log('✅ Microphone access granted');
      return true;
    } catch (err) {
      if (err.name === 'NotAllowedError') {
        alert('Microphone access denied. Please enable it in your browser settings.');
      } else if (err.name === 'NotFoundError') {
        alert('No microphone found on this device.');
      } else {
        alert('Failed to access microphone.');
      }
      console.warn('Mic access error:', err);
      return false;
    }
    /*if (!navigator.permissions) {
      console.warn('Permissions API is not supported in this browser.');
      return false;
    }

    try {
      const status = await navigator.permissions.query({ name: 'microphone' });
       if (status.state === 'granted') {
        return true;
      } else if (status.state === 'denied') {
        alert('Microphone access is denied. Please enable it in your browser settings.');
        return false;

      } else if (status.state === 'prompt') {
        alert(' Microphone permission not yet granted — will be asked when needed.');
        return false;
      }

      // You can optionally listen for changes:
      status.onchange = () => {
        console.log('Microphone permission changed to:', status.state);
      };
    } catch (err) {
      console.warn('Permission check failed:', err);
      return false;
    }*/
  };
  const handleVolumeUpDown = (text, fieldName) => {
    // Stop any ongoing speech first
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }

    // Reset all fields to not speaking
    setFieldConfig((prev) => {
      const updated = { ...prev };
      Object.keys(updated).forEach((k) => {
        updated[k].isVolume = false;
      });

      // Set this specific field to active (isVolume = true)
      updated[fieldName] = { isVolume: true };
      return updated;
    });

    // Speak text using SpeechSynthesis
    const speakWithVoice = () => {
      const utterance = new SpeechSynthesisUtterance(text);
      const voices = window.speechSynthesis.getVoices();

      const femaleVoice = voices.find((voice) =>
        voice.name.toLowerCase().includes("zira") ||
        voice.name.toLowerCase().includes("google us english") ||
        voice.name.toLowerCase().includes("female")
      );

      if (femaleVoice) utterance.voice = femaleVoice;

      utterance.lang = "en-US";
      utterance.rate = 1;
      utterance.pitch = 1;

      speechSynthesis.speak(utterance);
    };

    if ("speechSynthesis" in window) {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length > 0) {
        speakWithVoice();
      } else {
        window.speechSynthesis.onvoiceschanged = () => speakWithVoice();
      }
    } else {
      alert("Speech Synthesis not supported in this browser.");
    }
  };

  const handleVolumeUpDownReset = (fieldName) => {
    // Stop current speech
    if ("speechSynthesis" in window) {
      window.speechSynthesis.cancel();
    }

    // Reset the isVolume state for all fields
    setFieldConfig((prev) => {
      const updated = { ...prev };
      Object.keys(updated).forEach((k) => {
        updated[k].isVolume = false;
      });
      updated[fieldName] = { isVolume: false };
      return updated;
    });
  };

  const handleVoiceInput = async (fieldName) => {
    let micPermission = await checkMicPermission();
    console.log('micPermission', micPermission);

    if (!micPermission) {
      return;
    }
    if (activeField === fieldName) {
      SpeechRecognition.stopListening();
      setActiveField(null);
      resetTranscript();
      previousTranscriptRef.current = '';
    } else {
      SpeechRecognition.stopListening();
      resetTranscript();
      previousTranscriptRef.current = '';
      setActiveField(fieldName);
      // Wait 200ms before starting again
      setTimeout(() => {
        SpeechRecognition.startListening({ continuous: true, language: 'en-US' });
      }, 200);
    }
  };
  // ✅ Submit the final payload
  const handleSubmit = async () => {
    if (!patientDetail.referral_info) {
      showToast("error", "Referral info is required.");
      return;
    }

    if (!patientDetail.signature) {
      showToast("error", "Please provide a digital signature.");
      return;
    }

    try {
      setIsSubmit(true);
      const response = await CallWithAuth(
        "POST",
        MANAGE_PATIENT_INTAKE_FORM_API_URL + "?patientId=" + id,
        patientDetail
      );
      let message = errorMessageCreate(response?.res?.data?.message);

      if (response?.res?.data?.statusCode === 201) {
        showToast("success", message);
        setTimeout(() => {
          navigate("/patient-information");
          setIsSubmit(false);
        }, 1000);
      } else {
        showToast("error", message);
        setIsSubmit(false);
      }
    } catch (err) {
      console.error(err);
      showToast("error", "Error submitting patient intake form");
      setIsSubmit(false);
    }
  };

  return (
    <>
      <Header />
      <div className="container my-5 pt-5">
        <section className="clinical-intake-form">
          <div className="container">
            <h3>Patient Intake Form</h3>
            {/* <div className="form-cntn-box">
              <h5>Patient Intake Form</h5>
              <p>Manage and upload patient intake records</p>
            </div> */}
            <div className="form-cntn-box">
              <h5>Important Preface </h5>
              <p>
                We understand that your clinician has obtained your consent
                for your healthcare data to be collected by PsychScribe for
                the purpose of diagnostic clinical reasoning and report
                writing assistance. All the information you share in this form
                will be treated with strict confidentiality, de-identified to
                protect your privacy, and handled in accordance with the 1988
                Privacy Act, the Australian Privacy Principles (APP), and
                HIPAA guidelines.
              </p>
            </div>
            <div className="row">
              {/* ==================== TEXT FIELDS ==================== */}
              {[
                "referral_info",
                "present_concern",
                "medical_history",
                "developmental_history",
                "family_history",
                "social_history",
                "substance_use_history",
                "legal_history",
                "cultural_context",
                "phychosocial_trauma",
                "additional_info",
              ].map((field) => (
                <div className="col-md-6 col-12" key={field}>
                  <div className="form-group">
                    <div class="d-flex add-form-group-align">
                      <label class="ml-2">{field.replaceAll("_", " ").toUpperCase()} : </label>
                      {field?.isVolume === true ? (
                        <i
                          className="fa fa-volume-mute"
                          onClick={() => handleVolumeUpDownReset(field)}
                        />
                      ) : (
                        <i
                          className="fa fa-volume-up"
                          onClick={() => handleVolumeUpDown(field.replaceAll("_", " "), field)}
                        />
                      )}
                    </div>
                    <textarea
                      name={field}
                      className="form-control pr"
                      placeholder={`Enter ${field.replaceAll("_", " ")}`}
                      value={patientDetail[field]}
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      onClick={() => handleVoiceInput(field)}
                      className="microphone"
                    >
                      {/* {activeField === key ? "Stop" : "Voice to Text"} */}
                      {activeField == field ? (
                        <img
                          src={mutemic}
                          alt="microphone"
                          width="36"
                          height="36"
                        />
                      ) : (
                        <img
                          src={mic}
                          alt="microphone"
                          width="24"
                          height="24"
                        />
                      )}
                    </button>
                  </div>
                </div>
              ))}

              {/* ==================== RELATIVES ==================== */}
              <div className="col-12 col-md-12">
                <div className="form-group">
                  <label>Relatives Information</label>
                  <div className="relative-fields-add-form-sec">
                    {patientDetail.relatives.map((relative, index) => (
                      <div
                        key={index}
                        className="relative-fields-row"
                      >
                        <input
                          type="text"
                          placeholder="Name"
                          className="form-control"
                          value={relative.name}
                          onChange={(e) => {
                            const updatedRelatives = [...patientDetail.relatives];
                            updatedRelatives[index].name = e.target.value;
                            setPatientDetail((prev) => ({
                              ...prev,
                              relatives: updatedRelatives,
                            }));
                          }}
                        />
                        <input
                          type="email"
                          placeholder="Email"
                          className="form-control"
                          value={relative.email}
                          onChange={(e) => {
                            const updatedRelatives = [...patientDetail.relatives];
                            updatedRelatives[index].email = e.target.value;
                            setPatientDetail((prev) => ({
                              ...prev,
                              relatives: updatedRelatives,
                            }));
                          }}
                        />
                        <input
                          type="text"
                          placeholder="Phone"
                          className="form-control"
                          value={relative.phone}
                          onChange={(e) => {
                            const updatedRelatives = [...patientDetail.relatives];
                            updatedRelatives[index].phone = e.target.value;
                            setPatientDetail((prev) => ({
                              ...prev,
                              relatives: updatedRelatives,
                            }));
                          }}
                        />
                        <input
                          type="text"
                          placeholder="Relative Type"
                          className="form-control"
                          readOnly
                          value={relative.relative_type}
                          onChange={(e) => {
                            const updatedRelatives = [...patientDetail.relatives];
                            updatedRelatives[index].relative_type = e.target.value;
                            setPatientDetail((prev) => ({
                              ...prev,
                              relatives: updatedRelatives,
                            }));
                          }}
                        />
                        {
                          index !== 0 &&
                          <div className="signature-btns">
                            <button
                              type="button"
                              onClick={() => {
                                const updatedRelatives = patientDetail.relatives.filter(
                                  (_, i) => i !== index
                                );
                                setPatientDetail((prev) => ({
                                  ...prev,
                                  relatives: updatedRelatives,
                                }));
                              }}
                              className="clear-btn"
                            >
                              Remove
                            </button>
                          </div>}
                      </div>
                    ))}

                    <div className="relative-fields-submit-sec">
                      <button
                        type="button"
                        onClick={() =>
                          setPatientDetail((prev) => ({
                            ...prev,
                            relatives: [
                              ...prev.relatives,
                              { name: "", email: "", phone: "", relative_type: "relative" },
                            ],
                          }))
                        }
                        className="solid_cta cta_primary cta_with_icon"
                      >
                        Add Relative
                      </button>
                    </div>
                  </div>
                </div>
              </div>


              {/* ==================== FILE UPLOAD ==================== */}
              {/* <div className="field_block">
            <label>Upload Reports (.pdf/.doc/.docx)</label>
            <input
              type="file"
              name="reports"
              className="form-control"
              // accept=".pdf,.doc,.docx"
              onChange={handleFileChange}
              disabled={isFileLoading}
            />
            {isFileLoading && <p>Uploading...</p>}
          </div> */}
              <div
                className="col-md-12 col-12"
              // onDrop={(e) => handleDropPatientFaceImageFrom(e)}
              // onDragOver={handleDragOverPatientFaceImageFrom}
              // onDragLeave={handleDragLeavePatientFaceImageFrom}
              >
                <div className="form-group">
                  <div className="upload_field" style={{ width: '100%', maxWidth: '550px' }}>
                    <div className="title">
                      <label>Upload Reports (.pdf/.doc/.docx)</label>{" "}
                    </div>

                    <div className="upload_ui">
                      <label className="upload_ui_label d-block">
                        <input
                          type="file"
                          name="audio"
                          accept=".png, .jpg, .jpeg"  // Only allow image files
                          onChange={handleFileChange}
                          style={{ display: "none" }} // Hide input element
                          disabled={isFileLoading}
                        />
                        <div className="ui_inner">
                          <img src={upload_icon} alt="Upload" />
                          <h5>Upload</h5>
                          <p>
                            <span>Browse</span> to upload the file
                          </p>
                        </div>
                      </label>
                    </div>
                    {isFileLoading && <p>Uploading...</p>}
                    {
                      patientDetail?.files?.length > 0 &&
                      patientDetail?.files?.map((file, index) => {
                        console.log('file', file)
                        return (
                          <div className="uploaded-file-info" key={index}>
                            <p>Document File uploaded</p>
                            <p>
                              <span
                                className="file-name"
                                data-tooltip-id={`collateral-Information-tooltip-${file?.index}`}
                                data-tooltip-content={file.file}
                              >
                                {createShortNameFileDoc(file.file)}
                              </span>
                              <ReactTooltip
                                id={`collateral-Information-tooltip-${file?.index}`}
                                place="bottom"
                                variant="info"
                                className="custom-tooltip"
                                content={file.file}
                              />
                              <span className="file-type">
                                ({getFileType(file.file)})
                              </span>
                            </p>
                          </div>
                        )

                      })
                    }
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-12 field_block">
                <div className="form-group">
                  {/* ==================== DIGITAL SIGNATURE ==================== */}
                  <label>
                    Please provide a digital signature <sup className="text-danger">*</sup>.
                  </label>
                  <div className="signature-container">
                    <h3>Digital Signature</h3>
                    <ReactSignatureCanvas
                      ref={signaturePadRef}
                      penColor="black"
                      canvasProps={{
                        width: 550,
                        height: 200,
                        className: "signature-canvas",
                      }}
                    />
                    <div className="signature-btns">
                      <button onClick={clearSignature} className="clear-btn">Clear</button>
                      <button
                        onClick={saveSignature}
                        disabled={isSignatureLoading}
                        className="cta_primary"
                      >
                        Save Signature{" "}
                        {isSignatureLoading && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                      </button>
                    </div>
                    {digitalSignature && (
                      <p>
                        <strong>Signature saved:</strong>{" "}
                        <a href={digitalSignature} target="_blank" rel="noreferrer">
                          View
                        </a>
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <div className="form-submit-main-sec">
                    <button
                      disabled={isSubmit || isSignatureLoading}
                      onClick={handleSubmit}
                      className="solid_cta cta_primary cta_with_icon"
                    >
                      <span>Submit </span> <img src={rightArrow} alt="Arrow" />
                      {isSubmit && (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                    </button>
                    <ToastContainer />
                  </div>
                </div>
              </div>
            </div>



          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ManagePaitentIntakeForm;
